import React from 'react';

import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(() => ({
  title: {
    color: 'inherit',
    fontWeight: 400,
  },
}));

interface PublicAppBarTitleProps {
  title: string;
}

export function PublicAppBarTitle({ title }: PublicAppBarTitleProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <Typography className={classes.title} variant="h2">
      {title}
    </Typography>
  );
}
